import {
  Activity,
  Building2,
  ChevronRight,
  History,
  Inbox,
  LayoutDashboard,
  LogOut,
  Menu,
  Users,
  UsersRound,
  X,
} from 'lucide-react'
import { useEffect, useState } from 'react'
import { NavLink, Outlet, useLocation } from 'react-router-dom'
import { BRAND } from '../config/brand'
import { useAuthStore } from '../store/auth'
import { useUIStore } from '../store/ui'

const navigation = [
  { to: '/', label: '工作台', icon: LayoutDashboard, end: true },
  { to: '/employees', label: '员工邮箱', icon: Users },
  { to: '/groups', label: '群邮箱', icon: UsersRound },
  { to: '/public-mailboxes', label: '公共邮箱', icon: Inbox },
  { to: '/audit', label: '操作记录', icon: History },
]

const titles: Record<string, string> = {
  '/': '工作台',
  '/employees': '员工邮箱',
  '/groups': '群邮箱',
  '/public-mailboxes': '公共邮箱',
  '/audit': '操作记录',
}

export function AppShell() {
  const [mobileOpen, setMobileOpen] = useState(false)
  const location = useLocation()
  const user = useAuthStore((state) => state.user)
  const logout = useAuthStore((state) => state.logout)
  const notice = useUIStore((state) => state.notice)
  const clearNotice = useUIStore((state) => state.clear)

  useEffect(() => setMobileOpen(false), [location.pathname])

  return (
    <div className="app-shell">
      {mobileOpen && <button className="sidebar-scrim" aria-label="关闭菜单" onClick={() => setMobileOpen(false)} />}
      <aside className={`sidebar ${mobileOpen ? 'sidebar-open' : ''}`}>
        <div className="brand">
          <div className="brand-mark"><Building2 size={22} /></div>
          <div>
            <strong>{BRAND.shortName}</strong>
            <span>企业管理中心</span>
          </div>
          <button className="icon-button sidebar-close" aria-label="关闭菜单" onClick={() => setMobileOpen(false)}><X size={20} /></button>
        </div>
        <div className="service-state">
          <span className="pulse-dot" />
          <div><strong>邮件服务运行中</strong><small>Mox 引擎连接正常</small></div>
        </div>
        <nav className="main-nav" aria-label="主导航">
          <p className="nav-label">邮箱管理</p>
          {navigation.map(({ to, label, icon: Icon, end }) => (
            <NavLink key={to} to={to} end={end} className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
              <Icon size={19} />
              <span>{label}</span>
              <ChevronRight className="nav-chevron" size={16} />
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-company">
          <strong>{BRAND.companyNameZh}</strong>
          <span>{BRAND.companyNameEn}</span>
        </div>
        <div className="sidebar-footer">
          <div className="admin-avatar">管</div>
          <div className="admin-copy"><strong>{user?.username || 'admin'}</strong><span>超级管理员</span></div>
          <button className="icon-button dark" title="退出登录" aria-label="退出登录" onClick={() => void logout()}><LogOut size={18} /></button>
        </div>
      </aside>
      <div className="app-main">
        <header className="topbar">
          <div className="topbar-title">
            <button className="icon-button mobile-menu" aria-label="打开菜单" onClick={() => setMobileOpen(true)}><Menu size={21} /></button>
            <div><span>{BRAND.productName}</span><strong>{titles[location.pathname] || '管理中心'}</strong></div>
          </div>
          <div className="topbar-state"><Activity size={16} /><span>系统状态正常</span></div>
        </header>
        <main className="content"><Outlet /></main>
      </div>
      {notice && (
        <button className={`toast toast-${notice.kind}`} onClick={clearNotice}>
          {notice.message}
        </button>
      )}
    </div>
  )
}
